module.exports = __webpack_public_path__ + "media/images/PrepWorks-Logo_300_Light-216f92c7881d3b61cfd121cd1c54944d.png";